module.exports = __webpack_public_path__ + "fonts/BrandingSF-Black.3beb5f5b.ttf";